import { BasicModal, Button } from '../../Shared';

export const RecordingOptOutModal = ({ open, onClose, onConfirm }) => {
  return (
    <BasicModal open={open} onClose={onClose}>
      <div className="bg-white w-[560px] rounded-2xl shadow-[-40px_40px_80px_-8px_rgba(0,0,0,0.24)]">
        <div className="flex flex-col gap-1 pt-5 px-5 pb-4">
          <span className="text-base-1000 font-semibold text-[22px]/[28px]">
            Turn off recordings
          </span>
          <span className="text-base-1000 text-[18px]/[24px]">
            WARNING – IF YOU CLICK THIS BUTTON RECORDING FUNCTIONS ARE GONE
            FOREVER. Do you want to continue?
          </span>
        </div>
        <div className="flex items-center justify-end gap-3 py-4 px-5">
          <Button title="No" variant="blue" onClick={onClose} />
          <Button title="Yes" variant="error" onClick={onConfirm} />
        </div>
      </div>
    </BasicModal>
  );
};
